import React, { useState } from 'react';
import {Grid, Box, TextField, InputAdornment, IconButton, Button, Link, Typography} from '@mui/material';
import './account.css';
import '../../styles/brandingStyles/branding.css';
import resetPassBanner from '../../assets/userAccount/resetPassBanner.png';
import lockGreen from '../../assets/userAccount/lockGreen.png';
import { PersonOutline, LockOutlined, VisibilityOutlined, VisibilityOffOutlined, LoginOutlined, AlternateEmailOutlined, PhoneIphoneOutlined} from '@mui/icons-material';
import axios from 'axios';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'
import CustomAxios from '../../utils/CustomAxios';

export function ResetPassword(){
    
    const [email, setEmail] = useState('');
    const [showPassword, setShowPassword] = useState({
        password:false,
        conPassword:false
    });
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [resetLinkSent, setResetLinkSent] = useState(false);
    const [Errmessage, setErrMessage] = useState('')
    const [passErrmessage, setPassErrMessage] = useState('')
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();

    const handleTogglePasswordVisibility = (val) => {
        if(val === 'password'){
            setShowPassword((prev) => ({ ...prev, password: !prev.password }));

        }
        else{

            setShowPassword((prev) => ({ ...prev, conPassword: !prev.conPassword }));

        }
    };

    const resetPasswordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,12}$/;
    const isPasswordValid = resetPasswordRegex.test(password);
    const isConfirmPasswordValid = resetPasswordRegex.test(confirmPassword);

    const handleSubmit = (e) => {
        e.preventDefault()
        setPassErrMessage("")
        setErrMessage("")
        if (!isPasswordValid || !isConfirmPasswordValid){
            setPassErrMessage("Use 6-12 characters with at least one letter and one number.")
            return
        }
        if(password !== confirmPassword){
            setErrMessage("Ensure your new password matches the confirmation.")
            return
        }

        console.log('Signup data:', { password});
            const urlMemberId = searchParams.get("memberid");
            console.log("urlMemberId", urlMemberId)
            const details = urlMemberId ? urlMemberId : JSON.parse(window.sessionStorage.getItem("details")).oasis_id;
            // e.preventDefault();
    
            const payload = {
                email: details,
                // memberid: 31309,
                password: password
            };
    
            // Send data to the API endpoint using Axios (replace with your actual API endpoint)
            CustomAxios.post(`oasis/reset_password/`, payload)
            //axios.post('http://127.0.0.1:8000/oasis/reset_password/', payload)
                      .then(response => {
                // Handle API response as needed
                console.log('API Response:', response);
                if (response.data.message=="your password successfully changed"){
                    setResetLinkSent(true)
                }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
    };
    
    const isMobile = useMediaQuery({ maxWidth: 600 });

    return (
    <Box className='login-bg-primary' sx={{
        minHeight: "100vh",
        width : "100%"
    }}>
        <Grid container sx={{ minHeight: "100vh",padding: {xs:"20px"} }}>
        
        {/* Left Banner Section */}
        <Grid
            item
            xs={12}
            sm={7}
            className="login-bg-primary"
            sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
            }}
        >
            <Box
            component="img"
            src={resetPassBanner}
            alt="Reset Password Banner"
            sx={{ width: { xs: "100%", sm: "300px", md: "500px", lg: "initial" } }}
            />
        </Grid>

        {/* Right Form Section */}
        <Grid
            item
            xs={12}
            sm={5}
            sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            
            }}
        >
            <Box className="login-bg-primary-mem form" sx={{ width: "100%",marginTop: {xs:"20px"} }}>
            {resetLinkSent ? (
                <Box sx={{ textAlign: "center" }}>
                <Box className="fn-h3 fw-600 primary" sx={{ mb: 1 }}>
                    Your password has been reset successfully
                </Box>
                <Box className="pgh" sx={{ mb: 4 }}>
                    Please use your new password to log in
                </Box>
                <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => navigate('/login')}
                    startIcon={<LoginOutlined />}
                >
                    BACK TO LOGIN
                </Button>
                </Box>
            ) : (
                <form style={{ width: "100%",display: "flex", flexDirection: "column", gap: "20px" }}>
                <Box className="fn-h3 fw-600 primary text-center" >
                    Reset your password
                </Box>
                <Box className="pgh text-center" >
                    Enter a New Password below to change your current password.
                </Box>

                {/* New Password Field */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Box sx={{ color: "black", fontWeight: 700, fontSize: { xs: "14px", sm: "16px" }, lineHeight: { xs: "14px", sm: "24px" } }}>
                    New Password <span style={{ color: "#EF4444" }}>*</span>
                    </Box>
                    <TextField
                    placeholder="Enter New Password"
                    fullWidth
                    variant="outlined"
                    value={password}
                    type={showPassword.password ? 'text' : 'password'}
                    onChange={(e) => setPassword(e.target.value.replace(/\s/g, ''))}
                    error={password.length > 0 && !isPasswordValid}
                    helperText={password.length > 0 && !isPasswordValid ? 'Use 6-12 characters with at least one letter and one number.' : null}
                    inputProps={{ maxLength: 12 }}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">
                            <LockOutlined />
                        </InputAdornment>
                        ),
                        endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={() => handleTogglePasswordVisibility('password')}>
                            {showPassword.password ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                            </IconButton>
                        </InputAdornment>
                        )
                    }}
                    />
                    {passErrmessage && (
                    <Typography sx={{ color: "#EF4444", fontSize: "12px", mt: 1 }}>
                        {passErrmessage}
                    </Typography>
                    )}
                </Box>

                {/* Confirm Password Field */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Box sx={{ color: "black", fontWeight: 700, fontSize: { xs: "14px", sm: "16px" }, lineHeight: { xs: "14px", sm: "24px" } }}>
                    Re-Confirm <span style={{ color: "#EF4444" }}>*</span>
                    </Box>
                    <TextField
                    placeholder="Reconfirm password"
                    fullWidth
                    variant="outlined"
                    value={confirmPassword}
                    type={showPassword.conPassword ? 'text' : 'password'}
                    onChange={(e) => setConfirmPassword(e.target.value.replace(/\s/g, ''))}
                    error={(confirmPassword.length > 0 && !isConfirmPasswordValid) || (confirmPassword.length > 0 && confirmPassword !== password)}
                    helperText={
                        confirmPassword.length > 0 && !isConfirmPasswordValid
                            ? 'Use 6-12 characters with at least one letter and one number.'
                            : (confirmPassword.length > 0 && confirmPassword !== password ? 'Passwords do not match.' : null)
                    }
                    inputProps={{ maxLength: 12 }}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">
                            <LockOutlined />
                        </InputAdornment>
                        ),
                        endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={() => handleTogglePasswordVisibility("conPassword")}>
                            {showPassword.conPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                            </IconButton>
                        </InputAdornment>
                        )
                    }}
                    />
                    {Errmessage && (
                    <Typography sx={{ color: "#EF4444", fontSize: "12px", mt: 1 }}>
                        {Errmessage}
                    </Typography>
                    )}
                </Box>

                <Button type="submit" fullWidth variant="contained" color="primary" onClick={handleSubmit} disabled={!isPasswordValid || !isConfirmPasswordValid || password !== confirmPassword}>
                    RESET & SUBMIT
                </Button>
                </form>
            )}
            </Box>
        </Grid>
        </Grid>
    </Box>
    );

};